import CustomCalendar from "../views/CustomCalendar.js";

export default class GroupShow {

    constructor() {
        this.calendar = new CustomCalendar();
        window.application.setOnDataChangeListener(this);
    }

    onDataChanged(data) {
        this.calendar.onDataChanged(data);
    }

    onUpdate(){
        // No update actions needed for now
    }

    onDestroy(){
        this.calendar.onDestroy();
    }
}
